<template>
  <ul class="establishment-selection-list">
    <li
      v-for="(establishment, i) in establishments"
      :key="i"
      class="establishment-selection-list__item"
    >
      <router-link
        :to="{
          name: 'quote-overview-page',
          params: {
            establishmentId: establishment.EstablishmentNumber,
            cstType: 'b2c',
          },
        }"
        class="establishment-selection-list__link"
        data-qa="establishment-select-button"
      >
        <img :src="logoPath" width="150" class="establishment-selection-list__logo" alt="logo" />
        <div class="establishment-selection-list__establishment">
          <h5 class="establishment-selection-list__name">
            {{ establishment.Name }}
          </h5>
          <p class="establishment-selection-list__address">
            {{ establishment.Address }}, {{ establishment.City }}
          </p>
        </div>
        <span>
          <icon icon="chevron-right" />
        </span>
      </router-link>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'
import { getBrandName } from '@/helpers/BrandHelper'

export default {
  components: { Icon },
  computed: {
    ...mapState('establishments', ['establishments']),
    logoPath() {
      return `/wwwroot/images/logos/${getBrandName()}.jpg`
    },
  },
}
</script>

<style lang="scss" scoped>
.establishment-selection-list {
  list-style: none;

  &__item {
    margin-bottom: 1em;
    transition: all 0.2s ease-in-out;
  }

  &__link {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 1.25rem;
    border: 1px solid #dae2e5;
    border-radius: 0.25em;
    box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2);
    text-decoration: none;

    &:hover,
    &:focus {
      background-color: $gray-lightest;
      text-decoration: none;
    }
  }

  &__logo {
    margin-right: 20%;
  }
}
</style>
